import { createAction } from 'redux-dry-ts-actions';
import { copyStringToClipboard } from '../../utils/copyStringToClipboard';
export const viewLinkActions = {
  getViewlinks: createAction('GET_VIEWLINKS'),
  getViewlinksSuccess: createAction('GET_VIEWLINKS_SUCCESS', doc => doc),
  getViewlinksFailure: createAction('GET_VIEWLINKS_FAILURE', error => error),
  createViewlink: createAction('CREATE_VIEWLINK', info => info),
  createViewlinkSuccess: createAction('CREATE_VIEWLINK_SUCCESS', info => info),
  createViewlinkFailure: createAction('CREATE_VIEWLINK_FAILURE', error => error),
  updateViewlink: createAction('UPDATE_VIEWLINK', (linkId, oldViewLink, viewLink) => ({
    linkId,
    oldViewLink,
    viewLink
  })),
  updateViewlinkSuccess: createAction('UPDATE_VIEWLINK_SUCCESS', viewLink => viewLink),
  updateViewlinkFailure: createAction('UPDATE_VIEWLINK_FAILURE', error => error),
  removeViewlink: createAction('REMOVE_VIEWLINK', (linkId, deleteData) => ({
    linkId,
    deleteData
  })),
  removeViewlinkSuccess: createAction('REMOVE_VIEWLINK_SUCCESS', info => info),
  removeViewlinkFailure: createAction('REMOVE_VIEWLINK_FAILURE', error => error),
  copyToClipboard: createAction('COPY_TO_CLIPBOARD', viewLink => {
    copyStringToClipboard(viewLink);
    return {
      viewLink
    };
  }),
  logSocialShare: createAction('LOG_SOCIAL_SHARE', network => ({
    network
  }))
};